<template>
  <section>
    <expert-drawer></expert-drawer>
    <v-content>
      <v-container fill-height>
        <v-layout>
            <v-flex xs12 sm12>  <slot></slot> </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <expert-footer></expert-footer>
  </section>
</template>

<script>
import ExpertDrawer from "@/components/layout/expert_drawer.vue";
import ExpertFooter from "@/components/layout/expert_footer.vue";
export default {
  name: "ExpertLayout",
  components: {
    ExpertDrawer,
    ExpertFooter
  }
};
</script>


<style scoped>
    @media screen and (max-width: 439px){
        .sidebar{
            display:none;
        }
    }
</style>

